import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Chip,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageLayout from '../../components/layout/PageLayout';
import api from '../../api/config';
import { IMPORT_BUSINESSES } from '../../api/endpoints';
import { extractData } from '../../utils/response';
import { toast } from 'react-toastify';
import {
  buildImportBusinessRelationParams,
  getImportBusinessName,
  IMPORT_BUSINESS_DETAIL_FIELDS,
} from './importBusinessApiHelpers';
import { IMPORT_BUSINESSES_LIST_PATH } from '../../navigations/path';

const ViewImportBusiness = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(IMPORT_BUSINESSES.BY_ID(id), {
          params: buildImportBusinessRelationParams(),
        });
        if (!cancelled) setBusiness(extractData(data));
      } catch (err) {
        toast.error(err.response?.data?.message || 'Failed to load data record');
        navigate(IMPORT_BUSINESSES_LIST_PATH);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  if (loading || !business) {
    return (
      <PageLayout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={320}>
          <CircularProgress />
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(IMPORT_BUSINESSES_LIST_PATH)}
          sx={{ mb: 2 }}
        >
          Back to Data
        </Button>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
            {getImportBusinessName(business)}
          </Typography>
          <Chip
            label={IMPORT_BUSINESS_DETAIL_FIELDS[0].get(business)}
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>

        <Card>
          <CardContent sx={{ p: 3 }}>
            <Grid container spacing={2}>
              {IMPORT_BUSINESS_DETAIL_FIELDS.map(({ label, get }) => (
                <Grid item xs={12} sm={6} key={label}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    {label}
                  </Typography>
                  <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                    {get(business)}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </PageLayout>
  );
};

export default ViewImportBusiness;
